import { ArrowForwardIos } from "@mui/icons-material";
import { Divider, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import CustomIconButton from "../../../ui library/components/buttons/CustomIconButton";

import { FiltersButton } from "./FiltersButton";

const DrawerFilters = ({
  children,
  buttonTittle = "Filters",
  drawTittle = "Filters",
  triggerId = "drawer-filters-trigger",
  closeButtonId = "drawer-filters-close-button",
  icon = null,
  buttonSx = {},
  onOpen,
  closeSignal,
}) => {
  const [openFilter, setOpenFilter] = useState(false);

  const handleOpen = () => {
    if (typeof onOpen === "function") {
      onOpen();
    }
    setOpenFilter(true);
  };

  useEffect(() => {
    setOpenFilter(false);
  }, [closeSignal]);

  return (
    <>
      <FiltersButton
        id={triggerId}
        onClick={handleOpen}
        startIcon={icon}
        sx={buttonSx}
      >
        {buttonTittle}
      </FiltersButton>

      <aside
        role="dialog"
        aria-label="Filter panel"
        className={`absolute top-0 z-[1000] flex h-full w-[450px] transform flex-col rounded-bl-[10px] rounded-tl-[10px] border-r border-[#ececec] bg-white shadow-[4px_0_6px_-2px_rgba(0,0,0,0.2)] transition-transform duration-300 ease-out will-change-transform ${openFilter ? "left-0 translate-x-0" : "-left-10 -translate-x-full"} `}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between">
          <Typography className="p-2 pl-4 text-lg font-bold">{drawTittle}</Typography>
          <CustomIconButton
            tooltipText="Hide Filter Menu"
            classes="rotate-180 p-2"
            handleOnClick={() => setOpenFilter(false)}
            iconVisible={true}
            buttonId={closeButtonId}
            CustomIcon={<ArrowForwardIos className="text-sky-600" />}
          />
        </div>
        <Divider />
        {children}
      </aside>
    </>
  );
};

export default DrawerFilters;
